<div class="tab-bar" *ngIf="(tabs$ | async)?.length > 0">
  <button class="scroll-btn scroll-left" (click)="scrollLeft()" tabindex="-1">
    <mat-icon>chevron_left</mat-icon>
  </button>
  <div class="tab-bar-inner" #tabInner
       cdkDropList
       cdkDropListOrientation="horizontal"
       (cdkDropListDropped)="onDrop($event)">
    <div
      *ngFor="let tab of (tabs$ | async)"
      class="tab-item"
      cdkDrag
      cdkDragLockAxis="x"
      [class.active]="(activeTab$ | async) === tab.path"
      (click)="navigateTo(tab.fullPath)"
      (contextmenu)="onContextMenu($event, tab.path)">
      <mat-icon class="tab-icon">{{ tab.icon }}</mat-icon>
      <span class="tab-title">{{ tab.title }}</span>
      <button class="tab-close" (click)="close($event, tab.path)" matTooltip="Close tab">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <button class="scroll-btn scroll-right" (click)="scrollRight()" tabindex="-1">
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>

<!-- Context Menu -->
<div class="tab-context-menu"
     *ngIf="contextMenuVisible"
     [style.left.px]="contextMenuX"
     [style.top.px]="contextMenuY"
     (click)="$event.stopPropagation()">
  <button class="ctx-item" (click)="ctxClose()">
    <mat-icon>close</mat-icon>
    Close Window
  </button>
  <button class="ctx-item" (click)="ctxCloseOthers()">
    <mat-icon>tab_unselected</mat-icon>
    Close Other Windows
  </button>
  <button class="ctx-item" [disabled]="isFirstTab()" (click)="ctxCloseToLeft()">
    <mat-icon>arrow_back</mat-icon>
    Close Windows to the Left
  </button>
  <div class="ctx-divider"></div>
  <button class="ctx-item ctx-danger" (click)="ctxCloseAll()">
    <mat-icon>close_fullscreen</mat-icon>
    Close All Windows
  </button>
</div>
